import React from "react";
import { TimestampToDateMoment } from "../../../utils/timestampToDate";
import { NavLink } from "react-router-dom";
import { Alert } from "@material-ui/lab";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { useTranslation } from "react-i18next";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../styles/styledTable";
import { StyledBreakWord } from "../../styles/styledBreakWord";

const SupportUserList = ({ supportUsers }) => {
  const { t } = useTranslation("supportUserPage");

  if (!supportUsers) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (supportUsers.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable
        width="768"
        size="14"
        className="support-user-table"
      >
        <StyledTableHead
          scroll="auto"
          col="4"
          className="support-user-table__head"
        >
          <div>
            {t("table.firstname")}
          </div>
          <div>
            {t("table.lastname")}
          </div>
          <div>
            E-mail
          </div>
          <div>
            {t("table.createDate")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {supportUsers && supportUsers.map((value, key) => (
            <StyledTableRow
              key={key}
              scroll="auto"
              col="4"
              as={NavLink}
              to={"/support-user/" + value.id}
              className="support-user-table__row"
            >
              <StyledCol inline>
                <StyledBreakWord as="p">
                  {value.firstname ?? t("table.empty")}
                </StyledBreakWord>
              </StyledCol>
              <StyledCol inline>
                <StyledBreakWord as="p">
                  {value.lastname ?? t("table.empty")}
                </StyledBreakWord>
              </StyledCol>
              <StyledCol inline>
                <StyledBreakWord as="p">
                {value.email}
                </StyledBreakWord>
              </StyledCol>
              <StyledCol>
                {TimestampToDateMoment(value.createDate)}
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};
export default SupportUserList;